"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ENV = void 0;
var ENV = (document.querySelector('meta[name="x-server-env"]') || {
  content: 'dev'
}).content;
exports.ENV = ENV;